<template>
<b-container class="tz-flex">
  <div class="con">
    <!-- <div class="now-data-myself">
      <div class="now-data-myself-time">{{ date }}</div>
      <div class="now-data-myself-week">{{ week }}</div>
    </div> -->
    <Calendar ref="Calendar"
      v-on:choseDay="clickDay"
      v-on:changeMonth="changeDate"
      v-on:isToday="clickToday"
      :markDate.sync=marks
    ></Calendar>
  </div>
  <div class="tz-note">
      <div class="tz-note-tips">保持每天复盘，按自己的选股方法、原则、结合行业走势，进行后续仓位调整</div>
      <div class="tz-note-panel">
          <div class="tz-note-title"> <b-img thumbnail src="/static/image/dapan.png" /> 今日大盘行情</div>
          <div>
              <b-textarea v-model="tmp.market" placeholder="(收盘后先梳理上指、深成指、创业板指的走势) 如：截至收盘，沪指跌0.44%,深指跌1.19%,创业板指跌1.2%">
              </b-textarea>
          </div>
          <div class="tz-note-title"> <b-img thumbnail src="/static/image/gegu.png" /> 个股复盘</div>
          <div>
              <b-textarea v-model="tmp.stock" placeholder="">
              </b-textarea>
          </div>
          <div class="tz-note-title"> <b-img thumbnail src="/static/image/jihua.png" /> 明日计划</div>
          <div>
              <b-textarea v-model="tmp.plain" placeholder="持仓个股是否有重大信息公告或股价有异动（突然
大涨/突然大跌），搜集信息，了解是否有什么政策/消息影响公司经营?若影响，后期怎样操作？">
              </b-textarea>
          </div>
          <div class="tz-note-title"> <b-img thumbnail src="/static/image/fenxi.png" />持仓分析</div>
          <div>
              <b-textarea v-model="tmp.position" placeholder="">
              </b-textarea>
          </div>
          <div class="tz-note-title"><b-img thumbnail src="/static/image/guanzhu.png" />重点关注</div>
          <div>
              <b-textarea v-model="tmp.mark" placeholder="">
              </b-textarea>
          </div>
          <div class="tz-button-panel">
              <b-button class="tz-button" @click="addNote">提交</b-button>
          </div>
      </div>
  </div>
</b-container>    
</template>
<script>
import Calendar from 'vue-calendar-component';
import * as noteApi from '@/api/note';
export default {
     data() {
    return {
        date: "",
        week: "",
        marks: [],
        tmp:{
            noteDate: '',
            market: '',
            stock: '',
            plain: '',
            mark: '',
            position: '',
            id: ''
        }
        };
    },
    created() {
        var now = new Date();
        this.date = now.getDate();//得到日期
        var day = now.getDay();//得到周几
        var arr_week = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
        this.week = arr_week[day];
        noteApi.listDate().then(res=>{
          this.marks = res.data.noteDate
        })
    },
    components: {
        Calendar
    },
    methods: {
    clickDay(data) {
      var dt = new Date(data);      
      this.tmp.noteDate = dt;
      noteApi.getByDate( dt.Format("yyyy-MM-dd")).then(res=>{
        if(res.code==200){
          this.tmp = res.data
        }else{
          alert(res.msg)
        }         
      })
    },
    changeDate(data) {
      // console.log(data); //左右点击切换月份
    },
    clickToday(data) {
      // console.log(data); // 跳到了本月
    },
    addNote(){
        noteApi.add(this.tmp).then(res=>{
          if(res.code == 200){
            alert("提交成功")
          }
        })
    }
  }
}
</script>
<style>
.now-data-myself {
  width: 40%;
  position: absolute;
  border-right: 1px solid rgba(227, 227, 227, 0.6);
}
.con {
  position: relative;
  max-width: 280px;
}
.wh_content_all {
  background: transparent !important;
}
.wh_top_changge li {
  color: #0f1622 !important;
  font-size: 15px !important;
}
.wh_content_item, .wh_content_item_tag {
  color: #303133 !important;
}
.wh_content_item .wh_isToday {
  background: #00d985  !important;
  color: #fff  !important;
}
.wh_content_item .wh_chose_day {
  background: #409EFF  !important;
  color: #ffff  !important;
}
.wh_item_date:hover {
    background: rgb(217, 236, 255) !important;
    border-radius: 100px !important;
    color: rgb(102, 177, 255)  !important;
}
.wh_jiantou1[data-v-2ebcbc83] {
    border-top: 2px solid #909399;
    border-left: 2px solid #909399;
    width: 7px;
    height: 7px;
}
.wh_jiantou2[data-v-2ebcbc83] {
    border-top: 2px solid #909399;
    border-right: 2px solid #909399;
    width: 7px;
    height: 7px;
}
.wh_top_tag[data-v-2ebcbc83] {
  color: #409EFF;
  border-top: 1px solid rgba(227, 227, 227, 0.6);
  border-bottom: 1px solid rgba(227, 227, 227, 0.6);
}
.wh_container[data-v-2ebcbc83] {
    max-width: 280px;
}
/* .wh_top_changge[data-v-2ebcbc83] {
    display: flex;
    width: 50%;
    margin-left: 43%;
} */
.now-data-myself-time {
  color: #0f1622;
  font-size: 28px;
  height: 30px;
  font-family: "Helvetica Neue";
}
.now-data-myself-week {
  font-size: 10px;
  color: #909399;
}
.wh_top_changge .wh_content_li[data-v-2ebcbc83] {
  font-family: Helvetica;
}
.wh_content_item > .wh_isMark{
    background:#0264d2 !important;
    color: white;
}

</style>
<style scoped>
.tz-flex{
    display: flex;
    margin: auto;
}
.tz-note{
    width: 75%;
    color: black;
    margin-left: 10px;
}
.tz-note-panel{
    width: 100%;
    /* text-align: left; */
    font-weight: bold;
    font-size: 110%;
}
.tz-note-title{
    margin: 10px;
}
.tz-note-title img{
    width: 40px;
    background: transparent;
    border: none;
}
.tz-button {
    background-color: #ff7800;
    padding: 0 1rem 0 1rem;
    margin-right: 1rem;
    border-radius: 0;
    border: none;
    font-weight: bold;
}
.tz-button-panel{
    margin-top:10px;
}
.tz-note-tips{
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: #3b3bf8;
}
</style>


// WEBPACK FOOTER //
// src/views/system/note.vue